import React from "react";
import { Link } from "react-router-dom";
import "./BrandLogo.css";

/**
 * BrandLogo displays the logo and serves as the home link
 * @returns {JSX.Element} logo wrapped in a react-router-dom Link
 */
const BrandLogo = ({ color, className }) => {
    // Defines a function to render the appropriate logo based on the color prop
    const renderLogo = () => {
        if (color === "white") {
            return (
                <>
                    <img
                        src="https://assets.churchcamlive.ie/wp-content/plugins/ChurchCamLive/assets/images/logo-title-white.svg"
                        alt="White Logo"
                        className={`brand-logo ${className}`}

                    />
                </>
            );
        } else if (color === "blue") {
            return (
                <>
                    <img
                        src="https://assets.churchcamlive.ie/wp-content/plugins/ChurchCamLive/assets/images/logo-title.svg"
                        alt="Blue Logo"
                        className={`brand-logo ${className}`}
                    />
                </>
            );
        }
        return null;
    };
    return (
        <Link
            to="/"
            className="text-decoration-none"
        >
            {renderLogo()}{" "}
        </Link>
    );
};

export default BrandLogo;
